module.exports = __webpack_public_path__ + "img/thank_you.3b562927.svg";